import { createSlice } from "@reduxjs/toolkit";

export const menuTrackerSlice = createSlice({
    name: "menuState",
    initialState: {
        expandedIndex: {}
    },
  
    reducers: {
        setExpandedIndex: (state,action) => {
        return {...state, expandedIndex:action.payload }
      },
    },
  });

  export const {
    setExpandedIndex,
  } = menuTrackerSlice.actions;

  export default menuTrackerSlice.reducer;
